import { HtmlId } from '../enums/elementId';
import {
    IUnorderedVerticalListItem,
    UnorderedVerticalList,
    createUnorderedVerticalList,
} from '@vfde-brix/ws10/unordered-vertical-list';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { getBenefitsData } from '../util/cms';
import { BenefitsData, Tooltip } from '../interfaces/additionalPageOptions';
import { addTooltipTracking } from '../util/tracking';
import { mountToolTip } from './tooltip';
import { ITooltipProperties } from '@vfde-brix/ws10/tooltip';
import { AvcResult } from '@vfde-sails/avc-core';

export const mountVerticalList = (wrapperId: HtmlId) =>
    createComponentById(createUnorderedVerticalList, wrapperId, NO_PATTERN_BUSINESS_LOGIC);

const getTooltipProps = (tooltip: Tooltip): ITooltipProperties => ({
    business: NO_PATTERN_BUSINESS_LOGIC,
    stdTooltipId: tooltip.id,
    stdHeadline: tooltip.headline || undefined,
    txtContent: tooltip.text,
});

const getItem = (benefit: BenefitsData): IUnorderedVerticalListItem => ({
    business: NO_PATTERN_BUSINESS_LOGIC,
    stdHeadline: benefit.headline,
    txtText: benefit.subline,
    stdIcon: benefit.iconName,
    containerTooltip: benefit.tooltip ? getTooltipProps(benefit.tooltip) : undefined,
    optSize: 'default',
});

export const updateTariffBenefits = (
    comp: UnorderedVerticalList | null,
    tariffId?: string,
    avcResult?: AvcResult
) => {

    if (!comp || !tariffId) {
        return;
    }

    const props = comp.getProperties();
    const benefits = getBenefitsData(tariffId, avcResult);

    props.listUnorderedVerticalListItems = benefits?.map(getItem) || [];

    comp.update(props);

    props.listUnorderedVerticalListItems.map((item, index) => {
        const tooltipProps = item.containerTooltip;
        const tooltip = benefits?.[index]?.tooltip;

        if (tooltipProps && tooltip) {
            // Have to mount again because of component bug
            mountToolTip(tooltipProps.stdTooltipId as HtmlId, getTooltipProps(tooltip));
            addTooltipTracking(tooltipProps.stdTooltipId);
        }
    });
};
